module.exports = __webpack_public_path__ + "static/series_2800-73636654a785c0daa1ef299c3fdfb85d.png";